import { compose } from 'ramda';
import { branch, withProps } from 'recompose';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { registrationStatuses } from '../../constants';
import withCountDown from './withCountDown';

export const statuses = {
    NOT_STARTED: registrationStatuses.NOT_STARTED,
    COMPLETED: registrationStatuses.FINISHED
};

export const regPrefix = 'registration.';

export default compose(
    withProps(() => ({ statuses, regPrefix })),
    withCountDown,
    branch(
        ({ isCompleted }) => isCompleted,
        withProps(
            () => {
                const t = usePortletTranslations();
                return {
                    value: t(`${regPrefix}countDown.mode.ended.value`),
                    label: t(`${regPrefix}countDown.mode.ended.label`)
                };
            }
        )
    )
);
